module.exports = __webpack_public_path__ + "img/e7.71ea2607.jpg";